import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import DialogForm from '../../../Global/Modals/DialogForm';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { Formik, Field } from 'formik';
import ProgressButton from '../../../Global/Buttons/Progress';
import classnames from 'classnames';
import ButtonStyles from '../../../../styles/button';
import TypographyStyles from '../../../../styles/typography';
//import TextFieldInput from '../../../Global/Inputs/TextField';
import OutlinedSelectInput from '../../../Global/Inputs/OutlinedSelect';
import SpacingStyles from '../../../../styles/helpers/spacing';
import combineStyles from '../../../../utils/combineStyles';
import validationSchema from './CancelShipmentModal.schema';

export class CancelShipmentModal extends PureComponent {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    cancellationReasons: PropTypes.array.isRequired
  };

  state = { isSubmitting: false };
  _handleCancel = resetForm => {
    const { onClose } = this.props;
    resetForm();
    onClose();
  };

  render() {
    const {
      open,
      onClose,
      t,
      classes,
      onSave,
      cancellationReasons
    } = this.props;

    const { isSubmitting } = this.state;
    return (
      <Formik
        handleSubmit={this._handleOnSave}
        enableReinitialize={true}
        validateOnChange={false}
        validateOnBlur={false}
        validationSchema={validationSchema({ t })}
        initialValues={{
          shipmentCancellationReasonId: ''
        }}
        onSubmit={async (values, actions) => {
          this.setState({ isSubmitting: true });
          const savedSuccessfully = await onSave(values);
          if (savedSuccessfully) {
            actions.resetForm();
            this.setState({ isSubmitting: false });
            onClose();
          }
        }}
        render={({ values, handleChange, handleSubmit, handleReset }) => (
          <DialogForm
            open={open}
            title={t('Are you sure you want to cancel this shipment?')}
            onClose={onClose}
            footer={
              <Fragment>
                <div className={classes.spacer} />
                <Button
                  className={classes.button}
                  onClick={() => {
                    this._handleCancel(handleReset);
                  }}
                  color={'primary'}
                  classes={{ label: classes.buttonLabel }}
                >
                  {t(`No, Don't Cancel`)}
                </Button>
                <ProgressButton
                  color="primary"
                  className={classnames(classes.button)}
                  classes={{
                    label: classnames(classes.buttonLabel)
                  }}
                  onClick={handleSubmit}
                  isSubmitting={isSubmitting}
                >
                  {t('Yes, cancel')}
                </ProgressButton>
              </Fragment>
            }
          >
            <Grid container spacing={16}>
              <Grid item lg={12}>
                <p className={classes.body1Light}>
                  {`${t('To cancel, select a reason below')}.  (${t(
                    'Note: You will need to contact the carrier to confirm that the tender has been cancelled'
                  )}.)`}
                </p>
              </Grid>
              <Grid item lg={12} classes={{ item: classes.verticalGridItem }}>
                <Field
                  name={`shipmentCancellationReasonId`}
                  onChange={handleChange}
                  render={({ field, form }) => {
                    return (
                      <OutlinedSelectInput
                        value={values.shipmentCancellationReasonId}
                        field={field}
                        form={form}
                        label={t('Cancellation Reason')}
                        options={cancellationReasons}
                      />
                    );
                  }}
                />
              </Grid>
              {/*  <Grid item lg={12} classes={{ item: classes.verticalGridItem }}>
                <Field
                  value={values.shipmentCancellationNotes}
                  name={'shipmentCancellationNotes'}
                  label={t('Cancellation notes')}
                  onChange={handleChange}
                  component={TextFieldInput}
                />
              </Grid> */}
            </Grid>
          </DialogForm>
        )}
      />
    );
  }
}

const translatedCancelShipmentModal = withNamespaces()(CancelShipmentModal);
export default withStyles(
  combineStyles(SpacingStyles, TypographyStyles, ButtonStyles)
)(translatedCancelShipmentModal);
